import {
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  POST_USERS_UPDATE_PASSWORD_REQUEST,
  POST_USERS_UPDATE_PASSWORD_SUCCESS,
  POST_USERS_UPDATE_PASSWORD_FAILURE,
  GET_PASSWORD_SECURITY_QUESTION_REQUEST,
  GET_PASSWORD_SECURITY_QUESTION_SUCCESS,
  GET_PASSWORD_SECURITY_QUESTION_FAILURE,
} from "../../constants/ActionTypes";
import { UsersApi } from "../api/UsersApi";

const resetPasswordRequest = () => ({
  type: RESET_PASSWORD_REQUEST,
});

const resetPasswordSuccess = () => ({
  type: RESET_PASSWORD_SUCCESS,
});

const resetPasswordFailure = (error) => ({
  type: RESET_PASSWORD_FAILURE,
  payload: {
    error: error,
  },
});

export const resetPassword = (newPasswordInfo) => {
  return async (dispatch) => {
    dispatch(resetPasswordRequest());

    UsersApi.resetPassword(newPasswordInfo, dispatch)
      .then(() => {
        dispatch(resetPasswordSuccess());
      })
      .catch((error) => {
        dispatch(resetPasswordFailure(error.response));
      });
  };
};

/*** POST /users/me/update-password ***/
const postUsersUpdatePasswordRequest = () => ({
  type: POST_USERS_UPDATE_PASSWORD_REQUEST,
});

const postUsersUpdatePasswordSuccess = (user) => ({
  type: POST_USERS_UPDATE_PASSWORD_SUCCESS,
  payload: {
    user: user,
  },
});

const postUsersUpdatePasswordFailure = (error) => ({
  type: POST_USERS_UPDATE_PASSWORD_FAILURE,
  payload: {
    error: error,
  },
});

export function postUsersUpdatePassword(data) {
  return async (dispatch) => {
    dispatch(postUsersUpdatePasswordRequest());

    UsersApi.postUsersUpdatePassword(data, dispatch)
      .then((response) => {
        dispatch(postUsersUpdatePasswordSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(postUsersUpdatePasswordFailure(error.response));
      });
  };
}

/*** GET /password/security-question ***/
const getPasswordSecurityQuestionRequest = () => ({
  type: GET_PASSWORD_SECURITY_QUESTION_REQUEST,
});

const getPasswordSecurityQuestionSuccess = ({ security_question }) => ({
  type: GET_PASSWORD_SECURITY_QUESTION_SUCCESS,
  payload: { security_question: security_question },
});

const getPasswordSecurityQuestionFailure = (error) => ({
  type: GET_PASSWORD_SECURITY_QUESTION_FAILURE,
  payload: {
    error: error,
  },
});

export function getPasswordSecurityQuestion(data) {
  return async (dispatch) => {
    dispatch(getPasswordSecurityQuestionRequest());

    UsersApi.getPasswordSecurityQuestion(data, dispatch)
      .then((response) => {
        dispatch(getPasswordSecurityQuestionSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getPasswordSecurityQuestionFailure(error.response));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/ResetPassword.js